import type { HTMLAttributes, ReactNode } from 'react';
import type { Tone } from './types';
import { cn } from './utils';

type StatusBadgeProps = HTMLAttributes<HTMLSpanElement> & {
    label: string;
    tone?: Tone;
};

function StatusBadge({ label, tone = 'neutral', className, ...props }: StatusBadgeProps) {
    return (
        <span
            className={cn('nx-status-badge', `nx-status-badge--${tone}`, className)}
            {...props}
        >
            {label}
        </span>
    );
}

type CountBadgeProps = HTMLAttributes<HTMLSpanElement> & {
    count: number | string;
    tone?: Tone;
};

function CountBadge({ count, tone = 'neutral', className, ...props }: CountBadgeProps) {
    return (
        <span
            className={cn('nx-count-badge', `nx-count-badge--${tone}`, className)}
            {...props}
        >
            {count}
        </span>
    );
}

type ChipProps = HTMLAttributes<HTMLSpanElement> & {
    children: ReactNode;
};

function Chip({ children, className, ...props }: ChipProps) {
    return (
        <span className={cn('nx-chip', className)} {...props}>
            {children}
        </span>
    );
}

export { StatusBadge, CountBadge, Chip };
export type { StatusBadgeProps, CountBadgeProps };
